module.exports = __webpack_public_path__ + "img/level-curved-slice.8e821d54.svg";